import script from "./SearchContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchContent.vue?vue&type=script&lang=ts&setup=true"

import "./SearchContent.vue?vue&type=style&index=0&id=91f87816&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91f87816"]])

export default __exports__